@if (state.isOpen) {
  <div class="fixed inset-0 z-modal-top flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm"
    (click)="onBackdrop()">
    <div class="bg-white dark:bg-gray-900 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 p-6 w-full max-w-md"
      (click)="$event.stopPropagation()"
      data-confirm-dialog
      role="alertdialog" aria-modal="true">
      <div class="flex items-start gap-4">
        <div class="flex-shrink-0 flex h-12 w-12 items-center justify-center rounded-full {{ iconBgClass() }}">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="iconPath()"/>
          </svg>
        </div>
        <div class="flex-1 min-w-0 pt-0.5">
          @if (state.options.title) {
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1.5">{{ state.options.title }}</h3>
          }
          <p class="text-sm text-gray-600 dark:text-gray-300 whitespace-pre-line break-words">{{ state.options.message }}</p>

          @if (state.prompt) {
            <div class="mt-4">
              @if (state.prompt.inputType === 'textarea') {
                <textarea
                  rows="3"
                  [ngModel]="state.prompt.value"
                  (ngModelChange)="onPromptInput($event)"
                  [placeholder]="state.prompt.placeholder ?? ''"
                  class="w-full text-sm rounded-md border border-gray-300 bg-white text-gray-900 placeholder:text-gray-400 dark:bg-gray-800 dark:border-gray-700 dark:text-white px-3 py-2 focus:border-brand-500 focus:ring-1 focus:ring-brand-500 outline-none"
                  autofocus></textarea>
              } @else {
                <input
                  type="text"
                  [ngModel]="state.prompt.value"
                  (ngModelChange)="onPromptInput($event)"
                  [placeholder]="state.prompt.placeholder ?? ''"
                  class="w-full h-10 text-sm rounded-md border border-gray-300 bg-white text-gray-900 placeholder:text-gray-400 dark:bg-gray-800 dark:border-gray-700 dark:text-white px-3 focus:border-brand-500 focus:ring-1 focus:ring-brand-500 outline-none"
                  autofocus/>
              }
            </div>
          }
        </div>
      </div>
      <div class="mt-6 flex justify-end gap-2">
        @if (hasCancel) {
          <button type="button" (click)="onCancel()"
            class="px-4 py-2 text-sm font-medium rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
            {{ cancelLabel }}
          </button>
        }
        <button type="button" (click)="onConfirm()" [disabled]="confirmDisabled"
          class="px-4 py-2 text-sm font-medium rounded-md text-white shadow-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed {{ confirmBtnClass() }}">
          {{ state.options.confirmText }}
        </button>
      </div>
    </div>
  </div>
}
